import { CustomMessageTypes } from "./type";

export const FRIEND_CHAT_CUSTOM_TYPE = "friend_chat";
export const CHAT_CHANNEL_QUERY_LIMIT = 100;
export const SENDBIRD_REQUEST_CANCELED_CODE = 800_240;
export const GET_CHAT_CHANNELS_QUERY_KEY = ["chat-channels"];
export const CHAT_MESSAGE_SPACING = 5;
export const CARD_ACTIONS_BUTTON_HEIGHT_PX = 48;
export const PILLS_HEIGHT_PX = 28;
export const MESSAGE_INPUT_SPACING = 5;

export const HIDDEN_MESSAGE_TYPES: readonly string[] = [
  CustomMessageTypes.SHIFT_INVITE_RESPONSE,
  CustomMessageTypes.SHIFT_TIME_PROPOSAL_UPDATED,
  CustomMessageTypes.PLACEMENT_APPLICATION_AUTO_INTERVIEW_INVITE,
  CustomMessageTypes.PLACEMENT_APPLICATION_SUGGEST_INTERVIEW,
  CustomMessageTypes.SHIFT_ACTION,
  CustomMessageTypes.SHIFT_TIME_PROPOSAL_REPLIED,
];
